import React, { FC } from 'react';

import { Box, TextField } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';

interface RequiredFieldRowProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
}

const RequiredFieldRow: FC<RequiredFieldRowProps> = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  maxLength,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
    <Box sx={{ width: 28, display: 'flex', justifyContent: 'center', flexShrink: 0, mr: 1 }}>
      {required &&
        (value ? (
          <CheckCircleIcon fontSize="small" sx={{ color: 'success.main' }} />
        ) : (
          <ErrorIcon fontSize="small" sx={{ color: 'error.main' }} />
        ))}
    </Box>
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value.replace(/\s/g, '');
        if (!maxLength || newValue.length <= maxLength) onChange(newValue);
      }}
      variant="outlined"
      size="small"
      disabled={disabled}
      inputProps={maxLength ? { maxLength } : undefined}
    />
  </Box>
);

export default RequiredFieldRow;
